import { render, staticRenderFns } from "./CollectionRecord.vue?vue&type=template&id=50b66392&scoped=true"
import script from "./CollectionRecord.vue?vue&type=script&lang=ts"
export * from "./CollectionRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b66392",
  null
  
)

export default component.exports